module.exports = __webpack_public_path__ + "img/YVC-Logo-White.bb980142.svg";